import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { EMPTY_EQUIPMENT_CODE_IND_MAPPING_ENTITY, EquipmentCodeIndMappingEntity, } from "domain/entity/EquipmentCodeIndMapping/EquipmentCodeIndMappingEntity";
import { EquipmentCodeIndMappingRepository } from "domain/repository/EquipmentCodeIndMapping/EquipmentCodeIndMappingRepo";
import { ParameterDetailRepository } from "domain/repository/parameter/ParameterDetailRepo";
import _ from "lodash";
import { createEquipmentCodeIndMappingValidationSchema } from "presentation/constant/EquipmentCodeIndMapping/EquipmentCodeIndMappingValidationSchema";
import { Validation } from "presentation/constant/Validation";
import { EquipmentCodeIndMappingModel } from "presentation/model/EquipmentCodeIndMapping/EquipmentCodeIndMappingModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface EquipmentCodeIndMappingVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<EquipmentCodeIndMappingModel>> | ((value: SetStateAction<EquipmentCodeIndMappingModel>) => void),
    ],
    equipmentCodeIndMappingRepo: EquipmentCodeIndMappingRepository,
    parameterDetailRepo: ParameterDetailRepository,
}

export const EquipmentCodeIndMappingVM = ({ dispatch, equipmentCodeIndMappingRepo, parameterDetailRepo
}: EquipmentCodeIndMappingVMProps) => {
    const [equipmentCodeIndMappingDispatch] = dispatch;

    const loadDropdownOption = async () => {


        await parameterDetailRepo.getAllParameterDtlsByParameterCode("EQUIPMENT_CODE").then(
            equipmentCodeIndList => {
                const equipmentCodeIndDropdownOption = equipmentCodeIndList?.map((equipmentCodeInd) => ({
                    dropdownLabel: equipmentCodeInd.parameterDtlCode,
                    tagLabel: equipmentCodeInd.parameterDtlCode,
                    value: equipmentCodeInd.parameterDtlCode,
                })) ?? []

                equipmentCodeIndMappingDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        equipmentCodeDropdownOptions: equipmentCodeIndDropdownOption
                    }
                }))
            }
        )


    }

    const searchAllEquipmentCodeIndMappingList = async () => {
        equipmentCodeIndMappingDispatch(prevState => {
            return {
                ...prevState,
                currentRow: { ...EMPTY_EQUIPMENT_CODE_IND_MAPPING_ENTITY },
                currentEditRow: { ...EMPTY_EQUIPMENT_CODE_IND_MAPPING_ENTITY },
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                updatedRows: [],
                equipmentCodeIndMappingList: [],
            }
        })
        await equipmentCodeIndMappingRepo.searchAllEquipmentCodeIndMappingList().then(data => {
            if (data) {
                equipmentCodeIndMappingDispatch(prevState => {
                    return {
                        ...prevState,
                        equipmentCodeIndMappingList: data,
                    }
                })
            } else {
                equipmentCodeIndMappingDispatch(prevState => {
                    return {
                        ...prevState,
                        equipmentCodeIndMappingList: [],
                    }
                })
            }
        })
    }

    // const onRowDrag = (rows: EquipmentCodeIndMappingEntity[]) => {
    //     equipmentCodeIndMappingDispatch(prevState =>{ 
    //         const prevRows = prevState.equipmentCodeIndMappingList;
    //         const toChangedRows = rows.map((e, index) => ({...e,tempPriority: prevRows[index].priority})).filter(e=>e.tempPriority!==e.priority);

    //         return ({
    //             ...prevState,
    //             equipmentCodeIndMappingList: rows,
    //             updatedRows: toChangedRows,
    //     })})
    // }

    const onApply = async (updatedRows: EquipmentCodeIndMappingEntity[]) => {

        return await equipmentCodeIndMappingRepo.onApply(updatedRows);
    }

    const updateSelectedRows = async (rows: EquipmentCodeIndMappingEntity[]) => {

        equipmentCodeIndMappingDispatch(prevState => {
            return {
                ...prevState,
                selectedRows: rows,
                forceRefresh: !prevState.forceRefresh
            }
        })
    }

    const onHeaderFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        if (fieldKey === 'equipmentCodeList' && !val) {
            val = [];
        }
        equipmentCodeIndMappingDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldKey]: val,
                },
                masterState: {
                    ...prevState.masterState,
                    allFormState: {
                        ...prevState.masterState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const onRowDoubleClick = async (entity: EquipmentCodeIndMappingEntity) => {
        equipmentCodeIndMappingDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: entity,
                currentRow: entity,
                isShowEditPanel: true,
            }
        })
    }

    const onCloseEidtPanel = async () => {
        equipmentCodeIndMappingDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: { ...EMPTY_EQUIPMENT_CODE_IND_MAPPING_ENTITY },
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                masterState: {
                    ...prevState.masterState,
                    allFormState: {}
                }
            }
        })
    }

    const onSave = async (currentRow: EquipmentCodeIndMappingEntity) => {
        const valResult = await Validation(createEquipmentCodeIndMappingValidationSchema).ValidateFormOnly(currentRow);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            equipmentCodeIndMappingDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        }
        return equipmentCodeIndMappingRepo.onSave(currentRow);
    }

    const onSaveClicked = () => {
        equipmentCodeIndMappingDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }

    const onAddClick = async () => {
        equipmentCodeIndMappingDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: { ...EMPTY_EQUIPMENT_CODE_IND_MAPPING_ENTITY },
                isAdd: true,
                isShowEditPanel: true,
            }
        })
    }

    const onResetClick = async (isAdd: boolean) => {
        equipmentCodeIndMappingDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: isAdd ? { ...EMPTY_EQUIPMENT_CODE_IND_MAPPING_ENTITY } : prevState.currentRow,
            }
        })
    }
    const onEditClick = async () => {
        equipmentCodeIndMappingDispatch(prevState => {
            return {
                ...prevState,
                isEdit: true,
            }
        })
    }

    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        equipmentCodeIndMappingDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldName]: checked ? "Y" : "N",
                },
            }
        })
    }

    return {
        onCheckboxChange: onCheckboxChange,
        onResetClick: onResetClick,
        onEditClick: onEditClick,
        onAddClick: onAddClick,
        onSave: onSave,
        onCloseEidtPanel: onCloseEidtPanel,
        onRowDoubleClick: onRowDoubleClick,
        onHeaderFieldChange: onHeaderFieldChange,
        updateSelectedRows: updateSelectedRows,
        onApply: onApply,
        onSaveClicked: onSaveClicked,
        loadDropdownOption: loadDropdownOption,
        searchAllEquipmentCodeIndMappingList: searchAllEquipmentCodeIndMappingList,
    }
}